import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {LoginAdmin, Logout} from '../admin-shared/states/admin-auth/admin-auth.action';
import {first, takeUntil} from 'rxjs/operators';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Actions, ofActionErrored, ofActionSuccessful, Select, Store} from '@ngxs/store';
import {Observable, Subject} from 'rxjs';
import {AdminAuthState} from '../admin-shared/states/admin-auth/admin-auth.state';
import {AdminsUsers} from '../admin-shared/states/admin-auth/entities/AdminUser';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.scss']
})
export class AdminLoginComponent implements OnInit, OnDestroy {

  isLoading = false;
  private ngUnsubscribe = new Subject();

  @Select(AdminAuthState.getAdminAuth) currentUser: Observable<AdminsUsers>;
  currentU: AdminsUsers;

  errorMsg = false;
  loginDetail: FormGroup;
  showPwd = false;

  fieldTextType: boolean;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private store: Store,
    private actions$: Actions
  ) {

    this.actions$.pipe(ofActionSuccessful(LoginAdmin),
      takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.isLoading = false;
    });

    this.actions$.pipe(ofActionErrored(LoginAdmin),
      takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.isLoading = false;
      this.errorMsg = true;
    });

    this.currentUser.subscribe(
      (data) => {
        if (data) {
          const adminCheck = Number(data.roleID);
          if (!isNaN(adminCheck) && adminCheck < 20) {
            this.router.navigate(['/partners/admin/emailList']);
          } else if (!isNaN(adminCheck) && adminCheck < 99) {
            this.router.navigate(['/partners/overview/summary']);
          } else{
            this.store.dispatch(new Logout());
            this.router.navigate(['/partners']);
          }
        }
      });
  }

  ngOnInit(): any {
    this.loginDetail = this.fb.group({
      email : ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(200)])],
      pwd : ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(20)])],
    });
  }

  ngOnDestroy(): any{
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  get f(): any { return this.loginDetail.controls; }

  signIn(): any{
    this.submitted = true;
    this.errorMsg = false;
    if (this.loginDetail.invalid) {
      return;
    }
    this.isLoading = true;
    this.store.dispatch(new LoginAdmin(this.loginDetail.value.email, this.loginDetail.value.pwd))
        .pipe(first())
        .subscribe(
          data => {

          },
          error => {
            this.errorMsg = true;
            this.isLoading = false;
          });
  }

  toggleFieldTextType(): any {
    this.fieldTextType = !this.fieldTextType;
  }
}
